var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-radio',_vm._b({attrs:{"options":_vm.options,"name":_vm.$trans(_vm.row.name),"content":_vm.row.display_content},on:{"input":v => _vm.$emit('input', v)}},'input-radio',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }